/** 工作环境枚举 */
enum Enum_Environment {
  /** 数据监测 */
  IntelligentWarning,
  /** 实况监测 */
  FactsMonitor,
  /** 短临预报 */
  ShortImpending,
  /** 预报制作 */
  ForecastProduction,
  /** 模式预报 */
  ModeForecast,
  /** 智能网格 */
  IntelligentGrid,
  /** 决策服务 */
  DecisionService,
  /** 台风 */
  Typhoon,
  /** 保障专项 */
  Guarantee,
  /** 常规 */
  Convention,
  /** 检验 */
  Inspect,
  /** 常用 */
  Common,
  /** 复盘 */
  Replay,
  /** 设置 */
  SettingPanel,
  /** 风险预警 */
  RiskWarning,
  /** 书签 */
  Bookmark,
  /** 风险预警大屏 */
  RiskWarningBigScreen,
  /**   服务场景 */
  ServiceScenario,
}

export {
  Enum_Environment
}